import { ColumnDescription, SelectRowProps } from "react-bootstrap-table-next";
import Table from "../../../../../Components/Table";
import OrSpinner from "../../../../../Components/Utils/OrSpinner";
import { faArrowDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    IDocumentosTemplateModulo,
    IModulos,
} from "../../../../../Interfaces/Geral/TemplatesModulo/TemplatesModuloInterface";
import { Dispatch, SetStateAction } from "react";
import { Spinner } from "../../../../../Components/Loding/SpinnerPadrao";

interface IModulosVinculados {
    lstDocumentosTemplatesModulo: IDocumentosTemplateModulo | undefined;
    lstDocumentosTemplatesModuloLoading: boolean;
    // lstSelecionadosVinculados: React.MutableRefObject<IModulos[]>;

    lstSelecionadosVinculados: IModulos[];
    setLstSelecionadosVinculados: Dispatch<SetStateAction<IModulos[]>>;

    HandleDesvincularModuloUnico(row: IModulos): void;
    HandleDesvincularModuloTodos(): void;

    DesvincularTemplateModulosLoading: boolean;
}

export default function ModulosVinculados(props: IModulosVinculados) {
    const columns: Array<ColumnDescription<IModulos>> = [
        {
            dataField: "DS_MODULO",
            text: "Modulos Vinculados",
        },
        {
            dataField: "",
            text: "",
            isDummyField: true,

            formatter: (_, row) => (
                <div className="Button-Tools d-flex justify-content-center align-items-center">
                    <button
                        className="btn btn-outline-danger font-weight-bold mr-2"
                        onClick={() => {
                            props.HandleDesvincularModuloUnico(row);
                        }}
                        disabled={props.DesvincularTemplateModulosLoading}
                    >
                        {props.DesvincularTemplateModulosLoading ? (
                            <Spinner size="sm" />
                        ) : (
                            <FontAwesomeIcon
                                icon={faArrowDown}
                                size="lg"
                                className="mr-2"
                            />
                        )}{" "}
                        Desvincular
                    </button>
                </div>
            ),
        },
    ];

    const selectRowProp: SelectRowProps<IModulos> = {
        mode: "checkbox",
        clickToSelect: true,
        selected: props.lstSelecionadosVinculados.map((p) => p.ID_MODULO),

        onSelect: (row, isSelect) => {
            if (isSelect) {
                props.setLstSelecionadosVinculados([
                    ...props.lstSelecionadosVinculados,
                    {
                        ...row,
                    },
                ]);
            } else {
                props.setLstSelecionadosVinculados(
                    props.lstSelecionadosVinculados.filter(
                        (p) => p.ID_MODULO !== row.ID_MODULO
                    )
                );
            }
        },

        onSelectAll: (isSelect, rows: Array<IModulos>) => {
            if (isSelect) {
                props.setLstSelecionadosVinculados([
                    ...props.lstSelecionadosVinculados,
                    ...rows,
                ]);
            } else {
                props.setLstSelecionadosVinculados([]);
            }
        },
    };

    return (
        <OrSpinner
            loading={props.lstDocumentosTemplatesModuloLoading}
            spinner="capys"
        >
            <Table
                data={
                    props.lstDocumentosTemplatesModulo?.MODULOS.filter(
                        (lst) => lst.FL_VINCULADO === true
                    ) || []
                    // modulosFakes
                }
                columns={columns}
                keyField="ID_MODULO"
                selectRow={selectRowProp}
                noDataIndication={
                    <div className="text-center text-muted">
                        Nenhum módulo vinculado
                    </div>
                }
                loading={props.lstDocumentosTemplatesModuloLoading}
                wrapperClasses="wrapperTable mw-100 x-scroll"
                classes="tableClasses"
                bordered={false}
                center
                defaultStyle={{
                    align: "center",
                    classes: "p-2",
                }}
            />
            <div className="d-flex col-12 justify-content-center mb-3">
                <button
                    className="btn btn-outline-danger"
                    onClick={() => props.HandleDesvincularModuloTodos()}
                    disabled={
                        props.lstSelecionadosVinculados.length === 0 ||
                        props.DesvincularTemplateModulosLoading
                    }
                >
                    {props.DesvincularTemplateModulosLoading ? (
                        <Spinner size="sm" />
                    ) : (
                        <FontAwesomeIcon
                            icon={faArrowDown}
                            size="lg"
                            className="mr-2"
                        />
                    )}{" "}
                    Desvincular Selecionados
                </button>
            </div>
        </OrSpinner>
    );
}
